import { convertTimestampToReadableDate } from "./utils"

export const knowledgeAreaArray = [
    { value: "ca-agronomia-grad-ufsc", title: "Ciências Agrárias - Agronomia - Gradução - UFSC" },
    { value: "ca-florestal-grad-ufsc", title: "Ciências Agrárias - Engenharia Florestal - Graduação - UFSC" },
    { value: "ca-med-vet-grad-ufsc", title: "Ciências Agrárias - Medicina Veterinária/Zootecnia - Graduação - UFSC" },
    { value: "ca-pg-ag-flo-ufsc", title: "Ciências Agrárias - Agronomia/Engenharia Florestal - Pós Graduação - UFSC" },
    { value: "ca-pg-mv-zoo-ufsc", title: "Ciências Agrárias - Medicina Veterinária/Zootecnia - Pós Graduação - UFSC" },
    { value: "ca-grad-externas", title: "Ciências Agrárias - Graduação - Outras Instituições de Ensino" },
    { value: "ca-pg-externas", title: "Ciências Agrárias - Pós Graduação - Outras Instituições de Ensino" },
    { value: "ca-externas-empresas", title: "Ciências Agrárias - Empresas" },
]

export const linkResumo = "https://docs.google.com/document/d/1_VJ1gKcBGzTpaJZNsD_w8puBR5EnnXsO/edit?usp=sharing&ouid=109527995003317082119&rtpof=true&sd=true"
export const linkBanner = ""

export const UT = [
    { name: "Participante", link: "http://inscricoes.ufsc.br/3mostraparticipante" },
    { name: "Apresentador", link: "http://inscricoes.ufsc.br/3mostraapresentador" }
]

export const userTypes = [
    { value: "1", title: "Participante" },
    { value: "2", title: "Autor" },
    { value: "3", title: "Apresentador" },
    { value: "4", title: "Moderador" },
    { value: "5", title: "Avaliador" },
]

export const criteriaGradingRules = [
    { title: "Resumo (Todas as etapas do projeto)", name: "abstract" },
    { title: "Introdução (contextualização do tema, problema, hipótese, justificativa e objetivos)", name: "introduction" },
    { title: "Material e Métodos (concepção teórico-metodológica apresentada de forma a descrever adequadamente a execução do projeto)", name: "matnmet" },
    { title: "Resultados e discussão (apresentação clara e objetiva dos resultados e sua discussão com base na literatura científica) ", name: "resndis" },
    { title: "Conclusão (clara e direta enfatizando os principais resultados, correlacionando os a hipótese e objetivos do trabalho)", name: "conclusion" },
    { title: "Referências (correlacionada ao tema e, preferencialmente atualizada. De acordo com as normas da ABNT)", name: "ref" },
]

export const supportedImagesArray = [
    ".png",
    ".jpg",
    ".jpeg"
]

// 1h de banner exposto com video
export const minutesPerBanner = 60
// 10 perguntas e 20 de apres
export const minutesPerOral = 30

export const bannersPerHour = 2

export const secondEventDaystartsAt = 1616036400000

// Informações para geração das Tables
export const days = [
    [
        {
            start: 1615980600000,
            end: 1615991400000,
        },
        {
            start: 1616000400000,
            end: 1616007600000,
        }
    ],
    [
        {
            start: 1616067000000,
            end: 1616077800000,
        },
        {
            start: 1616086800000,
            end: 1616090400000,
        },
    ]
]

export const oralYtLink = 'http://youtu.be/x1VPHE-Aq2c'

export const oralPresentationStartTime = 1616090400000

export const hasSecondWaveBeenGenerated = true

export const finalBanners = false

export const isProductionMode = true

export const dbPrefix = isProductionMode ? "/mostrav3/" : "/teste3/"

// 14/03/2021 23:59:59
export const sendBannerLimit = 1615777199000

export const signUpLimit = {
    min: new Date('2024-07-09T00:00:00-03:00'),
    // min: Number.MIN_SAFE_INTEGER,
    max: new Date('2024-08-30T23:59:00-03:00')
}

export const signUpForParticipantsLimit = {
    // 18/2:
    min: Number.MAX_SAFE_INTEGER,
    // 27/11/2020 23:59:59
    max: Number.MAX_SAFE_INTEGER,
}

export const gradeAssignmentLimit = {
    min: new Date('2024-07-09T00:00:00-03:00'),
    // min: Number.MIN_SAFE_INTEGER,
    max: new Date('2024-09-06T23:59:00-03:00')
}

// 01/2:
export const gradeResult = Number.MAX_SAFE_INTEGER

export const linkToFolder = "https://drive.google.com/drive/folders/1MoIyBvJdwsogWkVwl4OmJsE1GA5EZC5v?usp=sharing"

export const datas = [
    { title: "Inscrições", date: "09/07/2024 a 11/09/2024 até 8:30" },
    {
        title: "Submissão de Resumos", date: convertTimestampToReadableDate(signUpLimit.min, true) + " até " + convertTimestampToReadableDate(signUpLimit.max, true)
    },
    { title: "Divulgação dos Resumos Aprovados", date: "06/09/2024" },
    { title: "Divulgação dos Trabalhos Selecionados para Apresentação Oral", date: "06/09/2024" },
    // { title: "Envio dos Banners", date: "23/02/2021 a 28/02/2021" },
    { title: "Evento", date: "11/09/2024 a 13/09/2024" },
    { title: "Premiação", date: "13/09/2024" },

]